import React, { PropsWithChildren } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';
import { LinkWrapper } from '../LinkWrapper/LinkWrapper';
import { Button, Row, Col, Image, Section } from '../../importCL';

interface IGlossaryTerms {
    term: string;
    htmlTag?: string;
    description: string;
    url?: string;
    relatedTerms: string[];
}

interface IGlossaryTermProps extends MappedComponentProperties {
    glossaryTerms?: IGlossaryTerms;
    adImagePath?: string; //desktop and mobile
    adLink?: string;
    adAltText?: string;
    backLink?: string;
}

export const GlossaryTermEditConfig = {
    emptyLabel: 'Glossary Term',
    isEmpty: (props: PropsWithChildren<IGlossaryTermProps>) => {
        return !props || !props.glossaryTerms;
    },
};

export const Split = (term: string) => {
    const relTerm = term.split('/').pop();
    if (relTerm && isNaN(parseInt(relTerm[0]))) {
        if (relTerm.includes('-')) {
            return relTerm.split('-').map(terms => terms[0].toUpperCase() + terms.slice(1)).join(' ')
                .replace(/\.[^/.]+$/, '');
        }
        return relTerm[0].toUpperCase() + relTerm.slice(1).replace(/\.[^/.]+$/, '');
    } 
    return relTerm;
};

const GlossaryTerm = (props: PropsWithChildren<IGlossaryTermProps>): JSX.Element => {
    const termTitleTag = props.glossaryTerms?.htmlTag || 'h1';
    return (
        <div id='glossary'>
            <Section className='!pt-16 !pb-0 !px-0'>
                <Row>
                    <Col sm={7}>
                        {React.createElement(
                            termTitleTag,
                            { className: 'mb-4 text-3xl leading-10 md:text-2xl md:leading-8' },
                            `${props.glossaryTerms?.term}?`,
                        )}
                        <>
                            {props.glossaryTerms?.description && transformHTMLParserLinks(props.glossaryTerms?.description)}
                        </>
                        <LinkWrapper href={props.backLink}>
                            <Button className='!pl-0 border-l-0' icon='back' size='medium' variant='link'>Back to Glossary</Button>
                        </LinkWrapper>
                    </Col>
                    <Col md={5}>
                        <h3 className='mb-6'>Related Terms</h3>
                        <div className='flex flex-wrap gap-[1.5rem]'>
                            {props.glossaryTerms?.relatedTerms && props.glossaryTerms?.relatedTerms.map((term, index) => {
                                return (
                                    <LinkWrapper key={index} href={`./${term.split('/').pop()}`}>
                                        <Button size='medium' variant='chip'
                                            key={index}>
                                            {Split(term)}
                                        </Button>
                                    </LinkWrapper>
                                );
                            })}
                        </div>
                        {props.adImagePath && (
                            <LinkWrapper href={props.adLink}>
                                <Image loading='lazy' className='mt-14' src={props.adImagePath} alt={props.adAltText}/>
                            </LinkWrapper>
                        )}
                    </Col>
                    <hr className='mt-16'/>
                </Row>
            </Section>
        </div>
    );
};

export default GlossaryTerm;
